import comp from "./CourseFilters";
export default comp;
